import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { Logo } from "./Logo";
import { ProfileMenu } from "./ProfileMenu";

export function Header() {
  const { go, cart, user, openSignInPanel, signOut } = useApp();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  // Close the mobile menu whenever the route changes (e.g. after a nav click).
  useEffect(() => setMenuOpen(false), [location.pathname]);

  if (location.pathname.startsWith("/personalize")) return null;

  const goHome = () => go({ name: "home" });

  const scrollToBooks = () => {
    if (location.pathname !== "/") {
      goHome();
      setTimeout(
        () => document.getElementById("books")?.scrollIntoView({ behavior: "smooth", block: "start" }),
        50
      );
    } else {
      document.getElementById("books")?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const emailInitial = user?.email.charAt(0).toUpperCase();

  return (
    <header className="hb-header">
      <div className="wrap hb-header-row">
        <a
          className="hb-logo"
          href="#"
          onClick={(e) => {
            e.preventDefault();
            goHome();
          }}
        >
          <Logo size={32} />
          hushberry
        </a>

        <nav className="hb-nav">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              scrollToBooks();
            }}
          >
            The Library
          </a>
          <a href="#">Our Story</a>
          {!user && (
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                openSignInPanel();
              }}
            >
              Sign in
            </a>
          )}
        </nav>

        <div className="hb-right">
          <button className="hb-cart" onClick={() => go({ name: "cart" })}>
            <span>Cart</span>
            <span className="badge">{cart.length}</span>
          </button>

          <ProfileMenu />

          <button
            className="hb-hamburger"
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
            aria-controls="hb-mobile-menu"
            onClick={() => setMenuOpen((v) => !v)}
          >
            {menuOpen ? <CloseIcon /> : <BarsIcon />}
          </button>
        </div>
      </div>

      {menuOpen && (
        <div id="hb-mobile-menu" className="hb-mobile-menu">
          <div className="wrap">
            <div className="hb-mobile-section">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToBooks();
                }}
              >
                The Library
              </a>
              <a href="#" onClick={() => setMenuOpen(false)}>
                Our Story
              </a>
              {!user && (
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    openSignInPanel();
                    setMenuOpen(false);
                  }}
                >
                  Sign in
                </a>
              )}
              <button
                type="button"
                onClick={() => {
                  go({ name: "cart" });
                }}
              >
                <span>Cart</span>
                <span className="badge">{cart.length}</span>
              </button>
            </div>

            {user && (
              <div className="hb-mobile-section hb-mobile-account">
                <div className="hb-mobile-email">
                  <span className="hb-profile-badge sm" aria-hidden>{emailInitial}</span>
                  <span>{user.email}</span>
                </div>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    go({ name: "orders" });
                  }}
                >
                  My Orders
                </a>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    void signOut();
                  }}
                >
                  Sign out
                </a>
              </div>
            )}
          </div>
        </div>
      )}
    </header>
  );
}

function BarsIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <path d="M3 6h18M3 12h18M3 18h18" strokeLinecap="round" />
    </svg>
  );
}

function CloseIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <path d="M6 6l12 12M18 6L6 18" strokeLinecap="round" />
    </svg>
  );
}
